var Menu = {
	firstLoad:true,
	places:{},
	breadcrumbs:[],
	currentMenu:null,
	hovering:{},
	icons:[],
	tip:{},
	lastFolder:null,
	forcedInfo: "",
	wheelWeight: 0,
	actives: {},
	rightIcons:null,

	removeHtml: function(str) {
		if (str == null || str == undefined) return "";
		
		str = str.replace(/(<([^>]+)>)/gi, ' ');
		str = str.replace("  ", " ");
		str = str.replace("  ", " ");
		return str;
	},

	register: function() {

		Tab.setGroup("wcag", "+");
		Tab.setGroup("hotspots", "+");
		Tab.setGroup("topmenu", "+");
		Tab.setGroup("topicons", "-");
		Tab.setGroup("volume", "+");
		Tab.setGroup("info", "+");
		Tab.setGroup("speech", "+");
		Tab.setGroup("iwindow", "+");
		Tab.setGroup("iwin.wcag", "+");
		Tab.setGroup("iwin.close", "+");

		Tab.setGroup("bottom", "+");

		Menu.helpTab = Menu.addTabToIcon("", "", "", 0);
	},

	init: function() {
		var self = this;

		AppEvent.on(player, "afterLoad", Menu.afterLoad);
		AppEvent.on(player, "PLACE.LOADED", Menu.placeLoaded);

		// TPL.lng('HTML5.wcag.contrast', "") " + TPL.lng("", "żółty tekst na czarnym tle") + "
		var contrast = "<div class='contrast'><a href='javascript:void(null);' title='" + TPL.lng("info.wcag.contrast_normal", "normalny kontrast") + "' class='ctr c0 speaks' data-speakgroup='TIPS' data-speak='HTML5.info.wcag.contrast_normal'>A</a>";
			contrast += "<a href='javascript:void(null);'  title='" + TPL.lng("info.wcag.white_on_black", "biały tekst na czarnym tle") + "' class='ctr c1 speaks' data-speakgroup='TIPS' data-speak='HTML5.info.wcag.white_on_black'>A</a>";
			contrast += "<a href='javascript:void(null);'  title='" + TPL.lng("info.wcag.black_on_yellow", "czarny tekst na żółtym tle") + "' class='ctr c2 speaks' data-speakgroup='TIPS' data-speak='HTML5.info.wcag.black_on_yellow'>A</a>";
			contrast += "<a href='javascript:void(null);' title='" + TPL.lng("info.wcag.yellow_on_black", "żółty tekst na czarnym tle") + "' class='ctr c3 speaks' data-speakgroup='TIPS' data-speak='HTML5.info.wcag.yellow_on_black'>A</a></div>";
		//TPL.lng('HTML5.wcag.fontsize', "")
		var wcag = "<div id='wcagpanel'>" + contrast + "<div class='brk'></div><div class='sizes'>";
			wcag += "<a href='javascript:void(null);' class='sz f1 speaks' data-speakgroup='TIPS' data-speak='HTML5.info.wcag.font_normal' title='" + TPL.lng("info.wcag.font_normal","normalna czcionka") + "'>A</a>";
			wcag += "<a href='javascript:void(null);' class='sz f2 speaks' data-speak='HTML5.info.wcag.font_bigger' title='" + TPL.lng("info.wcag.font_bigger","powiększona czcionka") + "' data-speakgroup='TIPS'>A<sup>+</sup></a>";
			wcag += "<a href='javascript:void(null);' class='sz f3 speaks' data-speak='HTML5.info.wcag.font_verybig' title='" + TPL.lng("info.wcag.font_verybig","bardzo powiększona czcionka") + "' data-speakgroup='TIPS'>A<sup>++</sup></a></div></div>";

		if (player.offline)			
			Menu.node = $("<div id='menu_container'><div id='hmenu'></div><div id='iwindow'><div class='tabs'><a href='javascript:void(null);' onclick='Menu.tab(1);' class='tab t1 selected'>Informacje</a><a href='javascript:void(null);' onclick='Menu.tab(2);' class='tab t2'>#</a></div><div class='wcag'><a href='javascript:void(null);' title='" + TPL.lng("info.wcagbutton", "Ustawienia dostępności") + "' onclick='Menu.toggleWcag();' id='wcagicon' class='speaks' data-speakgroup='TIPS' data-speak='HTML5.info.wcagbutton'>A</a></div> <a class='e speaks' data-speak='PLAYER.IWIN.FULL' data-speakgroup='TIPS' href='#' title='"+TPL.lng("tips.enlargewindow", "Powiększ okno")+"' onclick='Menu.infowindow_full();'><span class='fa fa-compress'></span></a><a class='x speaks' title='"+TPL.lng("tips.closeinfowindow", "Zamknij okno informacyjne")+"' data-speak='PLAYER.CLOSE' data-speakgroup='TIPS' href='#' onclick='Menu.infowindow();'><span aria-hidden='true'>&times;</span></a><div class='content'></div><div class='indicators'></div>" + wcag + "</div></div>");
		else
			Menu.node = $("<div id='menu_container'><div id='hmenu'></div><div id='iwindow'><div class='tabs'><a href='javascript:void(null);' onclick='Menu.tab(1);' class='tab t1 selected'>Informacje</a><a href='javascript:void(null);' onclick='Menu.tab(2);' class='tab t2'>#</a></div><div class='wcag'><a href='javascript:void(null);' title='" + TPL.lng("info.wcagbutton", "Ustawienia dostępności") + "' onclick='Menu.toggleWcag();' id='wcagicon' class='speaks' data-speakgroup='TIPS' data-speak='HTML5.info.wcagbutton'>A</a></div> <a href='javascript:void(null);' onclick='Menu.openPdf()' title='" + TPL.lng("info.openpdf", "Otwórz PDF") + "' class='speaks pdf' style='right: 60px; font-size: 12px;' data-speak='HTML5.info.openpdf' data-speakgroup='TIPS'>" + TPL.lng("info.openpdf", "Otwórz PDF") + "</a><a class='e speaks' data-speak='PLAYER.IWIN.FULL' data-speakgroup='TIPS' href='#' title='"+TPL.lng("tips.enlargewindow", "Powiększ okno")+"' onclick='Menu.infowindow_full();'><span class='fa fa-compress'></span></a><a class='x speaks' title='"+TPL.lng("tips.closeinfowindow", "Zamknij okno informacyjne")+"' data-speak='PLAYER.CLOSE' data-speakgroup='TIPS' href='#' onclick='Menu.infowindow();'><span aria-hidden='true'>&times;</span></a><div class='content'></div><div class='indicators'></div>" + wcag + "</div></div>");

		$("#ui").prepend($("<div class='menu_bg'></div>"));

//		Menu.node.append(TPL.render("menu-main", {}));
		$("#panels").append(Menu.node);

		$("#panels").on("mouseenter", ".sub", Menu.subHover);

		$("#player").on('mousemove', Menu.mousemove);

		$("#menu_container #wcagpanel .f1").on("click", function() {
			$("#iwindow .content").removeClass("size2");
			$("#iwindow .content").removeClass("size3");
		});

		$("#menu_container #wcagpanel .f2").on("click", function() {
			$("#iwindow .content").addClass("size2");
			$("#iwindow .content").removeClass("size3");
		});

		$("#menu_container #wcagpanel .f3").on("click", function() {
			$("#iwindow .content").removeClass("size2");
			$("#iwindow .content").addClass("size3");
		});

		var c = $("#iwindow");
		$("#menu_container #wcagpanel .c0").on("click", function() { c.removeClass('ctr1'); c.removeClass('ctr2'); c.removeClass('ctr3');});
		$("#menu_container #wcagpanel .c1").on("click", function() { c.addClass('ctr1'); c.removeClass('ctr2'); c.removeClass('ctr3');});
		$("#menu_container #wcagpanel .c2").on("click", function() { c.removeClass('ctr1'); c.addClass('ctr2'); c.removeClass('ctr3');});
		$("#menu_container #wcagpanel .c3").on("click", function() { c.removeClass('ctr1'); c.removeClass('ctr2'); c.addClass('ctr3');});

		SpeechManager.enableSpeech("#panels", ".speaks", 0, "TOPMENU");

		setTimeout(function() {
			$(".sub").each(function(idx) {
				if ($(this).attr("data-init-top") == undefined) {
					var top = parseInt($(this).css("top"));
					//console.log("top: " + top);
					$(this).attr("data-init-top", top);
				}
			});

			$('#panels').on('DOMMouseScroll', ".sub", Menu.onWheel);
			$('#panels').on('mousewheel', ".sub", Menu.onWheel);
			
		}, 3500);

		/*
		$('#panels').on("mouseout", ".speaks", function(e) {
			var ia = $(this);			

			if (self.hovering[ia.attr("data-speak")] != undefined && self.hovering[ia.attr("data-speak")] != null) {
				clearTimeout(self.hovering[ia.attr("data-speak")]);
			}
		});

		$('#panels').on("mouseover", ".speaks", function(e) {
			var ia = $(this);
			var ctime = Date.now();
			var grp = "TOPMENU";

//			if (Menu.hovering[ia.attr("data-speak")] == undefined || Menu.hovering[ia.attr("data-speak")] == null || ctime - Menu.hovering[ia.attr("data-speak")] > 2500) {
//				Menu.hovering[ia.attr("data-speak")] = ctime;
				if (ia.attr("data-speakgroup") != undefined) grp = ia.attr("data-speakgroup");

				self.hovering[ia.attr("data-speak")] = setTimeout(function() {
						SpeechManager.speakTip(ia.attr("data-speak"), grp);
						self.hovering[ia.attr("data-speak")] = null;
					}, 500);
//			}

		});
		*/

//		player.addProcess(this);
	},

	openPdf: function() {
		window.open("https://www.wkraj.pl/html5/pdf/doc.php?id=" + player.ident + "&lng=" + player.lang.toLowerCase());
	},

	toggleWcag: function() {
		$("#wcagpanel").toggleClass("wcagopen");
		$(".wcag a").toggleClass("wcagiconopen");

		if ($("#wcagpanel").hasClass("wcagopen")) {
			Tab.clearGroup("iwin.wcag");
			Menu.addBasicTab("iwin.wcag", $("#iwindow .c0"));
			Menu.addBasicTab("iwin.wcag", $("#iwindow .c1"));
			Menu.addBasicTab("iwin.wcag", $("#iwindow .c2"));
			Menu.addBasicTab("iwin.wcag", $("#iwindow .c3"));

			Menu.addBasicTab("iwin.wcag", $("#iwindow .f1"));
			Menu.addBasicTab("iwin.wcag", $("#iwindow .f2"));
			Menu.addBasicTab("iwin.wcag", $("#iwindow .f3"));
		} else {
			Tab.clearGroup("iwin.wcag");
		}
	},

	mousemove: function(e) {
		if (PROJECT.settings['html5/hover_bg'] == undefined || PROJECT.settings['html5/hover_bg'] == "1") {
			if (e.pageY < 200) {
				$(".menu_bg").css("opacity","1");
				$(".menu_bg").css("visibility","visible");
			} else {
				$(".menu_bg").css("opacity","0");
				$(".menu_bg").css("visibility","hidden");
			}
		}
	},

	/*
	process: function() {
		Menu.wheelWeight *= 0.9;
	},
	*/

	onWheel: function(e) {
		//var weight = 50;
		/*
		var weight = -6;
		var isWebkit = 'WebkitAppearance' in document.documentElement.style;

		if (isWebkit) weight = 0.2;

		var dt = e.originalEvent.wheelDelta;
		if (isNaN(dt)) dt = e.originalEvent.detail;
		*/

 		var dt = Math.max(-1, Math.min(1, e.originalEvent.wheelDelta || -e.originalEvent.detail));
 		/*
 		Menu.wheelWeight += dt * 25;
 		if (Menu.wheelWeight > 70) Menu.wheelWeight = 70;
 		if (Menu.wheelWeight < -70) Menu.wheelWeight = -70;
		*/

		//dt = Math.round(dt * Menu.wheelWeight);
		dt = Math.round(dt * 120); // 30

		var dm = $(this).offset();
		var top = dm.top;
		var total = parseInt($(this)[0].scrollHeight) + top;

		top = parseInt($(this).css("top"));
		
		if (total > $(window).height() - 50 || dt > 0) {
			$(this).css("top", top + dt);
		}		

		var itop = $(this).data("init-top");
		if (top + dt > itop) {
			$(this).css("top", itop);
		}
		
		e.preventDefault();			
		e.stopPropagation();
	},

	subHover: function(e) {
		/*
		var dm = $(this).offset();
		var top = dm.top;
		var total = parseInt($(this)[0].scrollHeight) + top;

		top = parseInt($(this).css("top"));
		if (total > $(window).height() - 50) {
			top --;
			$(this).css("top", top);
		}
		*/
		var top = 0;

		Menu.currentMenu = $(this);

		//console.log("sub hover");

		if ($(this).attr("data-init-top") == undefined) {
			top = parseInt($(this).css("top"));
			$(this).attr("data-init-top", top);
		}

		e.stopPropagation();
	},

	hexToRgbA: function(hex, a) {
	    var c;
	    if(/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)){
	        c= hex.substring(1).split('');
	        if(c.length== 3){
	            c= [c[0], c[0], c[1], c[1], c[2], c[2]];
	        }
	        c= '0x'+c.join('');
	        return 'rgba('+[(c>>16)&255, (c>>8)&255, c&255].join(',')+',' + a + ')';
	    }
	    return "";
	},

	getMenuColor: function(item) {
		var a = "0.8";
 		if (item.color == undefined || item.color == 0 || item.color == "") return "transparent";
 		if (item.color == "1") return "rgba(155,0,0," + a + ")";
 		if (item.color == "2") return "rgba(0,155,0," + a + ")";
 		if (item.color == "3") return "rgba(0,0,155," + a + ")";
 		if (item.color == "4") return "rgba(0,155,155," + a + ")";
 		if (item.color == "5") return "rgba(155,155,0," + a + ")";
 		if (item.color == "6") return "rgba(50,0,0," + a + ")";
 		if (item.color == "7") return "rgba(0,0,255," + a + ")";
 		if (item.color == "8") return "rgba(240,123,6," + a + ")";
 		if (item.color == "9") return "rgba(255,255,255," + a + ")";

 		return Menu.hexToRgbA(item.color, 0.8);
	},

 	renderMenuItem: function(item) {
 		if (item.color == undefined || item.color == "")
 			return item.title;
 		else 
 			return item.title;
// 			return "<span style='color:" + Menu.getMenuColor(item) + "'>" + item.title + "</span>";
 	},

	submenu: function(childs, tbg, first) {
		var m = "";
		var otbg = tbg;

		if (childs && childs.length > 0) {
			var haschilds = false;
			for(var n in childs) {
				if (childs[n].childs) {
					haschilds = true;
					break;
				}
			}
			if (childs.length < 10) haschilds = true;

			/*
			if (haschilds)
				m = "<div class='sub' style='background-color:" + tbg + "'>";
			else
				m = "<div class='sub' style='width:630px' style='background-color:" + tbg + "'>";
			*/

			var cls = "sub";

			if (first) cls += " firstsub";

			var style = "";

			if (otbg != "transparent") {
				style = "background-color: transparent;"
			}

			if (PROJECT.settings['html5/submenu_opacity'] != undefined) {
				style = "background-color: rgba(0,0,0," + (1 - parseFloat(PROJECT.settings['html5/submenu_opacity'])) + ");";
			}


			if (haschilds)
				m = "<div class='" + cls + "' style='" + style + "'>";
			else
				m = "<div class='" + cls + "' style='width:607px;column-count:2;" + style + "'>";

			var cc = null;
			var style = "";

			for(var n in childs) {
				tbg = otbg;

				cc = Menu.getMenuColor(childs[n]);

				var look = 0;
				if (childs[n].look_at) look = childs[n].look_at;
				if (childs[n].look_at_y != null && childs[n].look_at_y != undefined) look += "," + childs[n].look_at_y;

				var click = "";
				if (Menu.places[childs[n].pano_id] && (Menu.places[childs[n].pano_id]['type'] == 'panorama' || Menu.places[childs[n].pano_id]['type'] == 'photo')) {
					click = "onclick='Menu.openUrlEvt(\"" + childs[n].pano_id + "\", false, \"" + look + "\", event);'";
				}

				if (cc != "transparent") {
					tbg = cc;
					style = "background-color:" + cc;
				} else if (otbg != "transparent") {
					style = "background-color:" + otbg;
				}

				var active = "";
				//if (player.ident == childs[n].pano_id) active = " activemenu"; else active = "";

				var spk = " data-speak='" + childs[n].title + "'";

				var ltitle = Menu.removeHtml(Menu.renderMenuItem(childs[n]));
				if (childs[n].pano_id.indexOf("link=") !== -1) ltitle = "Otwórz link \"" + Menu.removeHtml(Menu.renderMenuItem(childs[n])); + "\" w nowej zakładce";

				if (childs[n].childs)
					m += "<div class='menuitem subitems speaks" + active + "' title='" + ltitle + "' " + spk + " style='" + style + "' " + click + ">";
				else
					m += "<div class='menuitem speaks" + active + "' title='" + ltitle + "' " + spk + " style='" + style + "' onclick='Menu.openUrlEvt(\"" + childs[n].pano_id + "\", false, \"" + look + "\", event);'>";

				/*
				if (cc == 'transparent') {
					m += "<div class='menuitem'>";
//					tbg = otbg;
				} else {
					m += "<div class='menuitem' style='background-color:" + cc + "'>";
//					tbg = cc;
				}
				*/

				var childid = (childs[n].childs ? "<div class='more' style='pointer-events:none;'>&raquo;</div>" : "");

				if ((Menu.places[childs[n].pano_id] && (Menu.places[childs[n].pano_id]['type'] == 'panorama' || Menu.places[childs[n].pano_id]['type'] == 'photo') || (childs[n].glyph != undefined && childs[n].glyph != ""))) {

					//m += "<div class='img'><img src='" + Menu.places[childs[n].pano_id]['thumb'] + "'></div>";
					var thumb;

					thumb = Menu.places[childs[n].pano_id] != undefined ? Menu.places[childs[n].pano_id]['thumb'] : "";
					if (childs[n].glyph != undefined && childs[n].glyph != "")  thumb = childs[n].glyph;
					m += "<div class='img'><img data-src='" + thumb + "' height='45' style='opacity:0'></div>";
					//m += "<div class='img'><img src='' height='45'></div>";
					m += "<span><a href='#' class='part'>" + Menu.renderMenuItem(childs[n]) + childid + "</a></span>";
				} else {
					m += "<a href='#' class='" + (childid != "" ?"subitems" : "") + "'>" +  Menu.renderMenuItem(childs[n]) + childid + "</a>";
				}

				m += Menu.submenu(childs[n].childs, tbg, false);
				m += "<div class='clear'></div></div>";
			}
			m += "</div>";
		}

		return m;
	},

	hoveringEvt: function(self) {
//		$($($(self).parent()).find('.sub')).css("display", "");
		$($(self).find('.sub')).css("display", "");

//		var el = $($(self).parent()).find('.sub');
		var el = $(self).find('.firstsub');
		var pos = $(self).offset()

		if (pos.left + el.width() > $(window).width()) {
			var dif = (pos.left + el.width()) - $(window).width();
			el.css("left", "-" + dif + "px");
		} else {
			el.css("left", "0px");
		}
	},

	afterLoad: function(data) {
		Menu.prepareBc(data);
	},

	prepareBc: function(data) {
//		alert("after load menu");
		Menu.placedata = data;

		Menu.breadcrumbs = [];

		Menu.topMenuIndex = 0;

		/*
		if (data.place_type == 'gallery' || data.place_type == 'catalogue3D') {
			$("#hmenu").addClass('forcehide');
		} else {
			$("#hmenu").removeClass('forcehide');
		}
		*/

		//Menu.hideinfowindow();
		Menu.updateInfoText(1);

		for(var n in data.menu) {
			var m = data.menu[n];

			if (Menu.inMenu(m.childs) || m.pano_id == player.ident) {
				Menu.topMenuIndex = n;
				Menu.breadcrumbs.push({"title": m.title, 'index': n});
				var hm = $($("#hmenu .bcmenu")[n]);

				if (hm && hm.length > 0) $("#menu_breadcrumbs").css("left",$($("#hmenu .bcmenu")[n]).position().left);
			}

		}

		var bcs = "";
		for(var i = Menu.breadcrumbs.length - 1; i >= 0; i --) {
			var t = Menu.strip(Menu.breadcrumbs[i].title);
			if (i == 0) t = "<b>" + t + "</b>";
			bcs += t + (i > 0 ? " <i class='fa fa-caret-right' aria-hidden='true'></i> " : "");
		}

		var topmenu = null;
		Menu.node.find(".bcmenu .topmenu").removeClass('active');
		Menu.node.find(".bcmenu .menuitem").removeClass('active');

		if (Menu.breadcrumbs != undefined && Menu.breadcrumbs.length > 0) {
			topmenu = $(Menu.node.find(".bcmenu")[Menu.breadcrumbs[Menu.breadcrumbs.length - 1].index]);
			topmenu.find('.topmenu').addClass('active');

			topmenu = topmenu.children(".sub")

			if (Menu.breadcrumbs.length > 1)
				for(var i = Menu.breadcrumbs.length - 2; i >= 0; i --) {
					topmenu = $(topmenu.children(".menuitem")[Menu.breadcrumbs[i].index]);
					topmenu.addClass('active');
					topmenu = topmenu.children(".sub");
				}
		}


		if (bcs && bcs != "") {
			$("#menu_breadcrumbs").html(bcs);
			$("#menu_breadcrumbs").show();
		} else {
			$("#menu_breadcrumbs").hide();
		}

		//console.log(Menu.breadcrumbs);
	},

	strip: function(html)
	{
		var tmp = document.createElement("DIV");
		tmp.innerHTML = html;
		return tmp.textContent || tmp.innerText || "";
	},

	addBasicTab: function(group, node, focus, keyboard) {
		Tab.add(group, {
			"focus": function(m) {
				m.node.addClass("focused");
				if (m.focus == undefined) m.node.focus();
				else m.focus.focus();
			},

			"blur": function(m) {
				m.node.removeClass("focused");
			},

			"keyboard": keyboard != undefined ? keyboard : function() {

			}

		}, {"node": node, "focus": focus});

	},

	addTabToIcon: function(title, glyph, ico, sub, subsel, itemsel, toggle, snode) {
		var d = {"title": title, "glyph": glyph, "node": ico, "subnode": (snode == undefined ? ico : snode)};

		if (subsel == undefined) subsel = ".submenu";
		if (itemsel == undefined) itemsel = "span";

		var res = Tab.add("topicons", {
			"action": function(m) {
				//console.log("action");
				//console.log(m);

				m.opened = m.opened == undefined ? true : !m.opened;
				if (toggle == undefined)
					m.node.find(".topicon").toggleClass("hovered");
				else
					toggle();

				if (m.midx != -1) {
					//console.log("MIDX ENTER");
					$(m.items.eq(m.midx)).click();
					event.preventDefault();
					event.stopPropagation();
				}
			},

			"focus": function(m) {
//				console.log("focus " + m.title);
				m.node.find(".topicon").addClass("focused");
				m.node.find(".topicon").focus();
				m.midx = -1;
				m.items = m.subnode.find(subsel).children(itemsel);
			},

			"blur": function(m) {
//				console.log("blur " + m.title);

				m.node.find(".topicon").removeClass("focused");
				if (toggle == undefined)
					m.node.find(".topicon").removeClass("hovered");
				else if (m.opened) toggle();

				m.opened = false;
			},

			"keyboard": function(m, event) {
				//if (m.node.find(".topicon").hasClass("hovered")) {
				if (m.opened) {
					player.keys['ArrowLeft'] = 0;
					player.keys['ArrowRight'] = 0;
					player.keys['ArrowUp'] = 0;
					player.keys['ArrowDown'] = 0;
				}

				if (event.key == "ArrowDown") {
					if (m.midx >= $(m.items).length - 1) return;

					m.node.find(".topicon").removeClass("focused");
					if (m.midx > -1) $(m.items.eq(m.midx)).removeClass("selected focused");
					m.midx ++;
					$(m.items.eq(m.midx)).addClass("selected focused");
					$(m.items.eq(m.midx)).trigger("speaks");
				};

				if (event.key == "ArrowUp" && m.midx >= 0) {
					m.node.find(".topicon").removeClass("focused");
					if (m.midx > -1) $(m.items.eq(m.midx)).removeClass("selected focused");
					m.midx --;
					if (m.midx > -1) {
						$(m.items.eq(m.midx)).addClass("selected focused");							
						$(m.items.eq(m.midx)).trigger("speaks");
					}
				} else if (m.midx < 0) {
					m.node.find(".topicon").addClass("focused");
					m.node.find(".topicon").focus();					
				}
			}


		}, d, sub);

		return res;
	},

	prepIcon: function(glyph, title, speech_symbol, tti) {
		var cm = "";
		cm += "<div class='top right' style='pointer-events:none;'>";
		cm += "<a href='#' aria-hidden='true' class='topicon righticon speaks ttip' data-ttip='" + title + "' data-speakgroup='TIPS' data-speak='" + speech_symbol + "'><i class='fa " + glyph + "' aria-hidden='true'></i><span class='tip'></span></a>";
		cm += "</div>";
		var ico = $(cm);

		Menu.icons.push(ico);

		var t = null;

		if (tti == undefined)
			t = this.addTabToIcon(title, glyph, ico);
		else
			t = this.addTabToIcon(title, glyph, ico, tti.sub, tti.subsel, tti.itemsel, tti.toggle, tti.node);

		ico.tab = t;

		return ico;
	},

	prepIconSvg: function(glyph, title, speech_symbol, tti, href) {
		var cm = "";
		cm += "<div class='top right' style='pointer-events:none;'>";
		if (href == undefined)
			cm += "<a href='#' aria-hidden='true' class='topicon righticon speaks ttip' data-ttip='" + title + "' data-speakgroup='TIPS' data-speak='" + speech_symbol + "' style='padding:7px;'><img src='" + glyph + "' width='25' aria-hidden='true' style='pointer-events:none;'><span class='tip'></span></a>";
		else {
			cm += "<a href='" + href.url + "' target='" + href.target + "' aria-hidden='true' class='topicon righticon speaks ttip' data-ttip='" + title + "' data-speakgroup='TIPS' data-speak='" + speech_symbol + "' style='padding:7px;'><img src='" + glyph + "' width='25' aria-hidden='true' style='pointer-events:none;'><span class='tip'></span></a>";
		}
		cm += "</div>";
		var ico = $(cm);

		Menu.icons.push(ico);

		var t = null;

		if (tti == undefined)
			t = this.addTabToIcon(title, glyph, ico);
		else
			t = this.addTabToIcon(title, glyph, ico, tti.sub, tti.subsel, tti.itemsel, tti.toggle, tti.node);

		ico.tab = t;

		return ico;
	},

	placeLoaded: function() {		
		var data = Menu.placedata;
		//console.log(data.menu);

		Menu.data = data;

		Menu.actives = {};

		Tab.clearGroup("info");

		if (Menu.firstLoad || Menu.lastFolder != data.folder.city_id) {
			var hm = $("#hmenu");

			hm.html("");

			Menu.places = data.menuplaces;

			Menu.lastFolder = data.folder.city_id;

			var ms = 0;

			var cs = "";

			if (window.PROJECT.settings['ui/icons/info/bg'] != undefined && window.PROJECT.settings['ui/icons/info/bg'] != "") {
				cs = "background-color: " + window.PROJECT.settings['ui/icons/info/bg'];
			}

			var cc = "";
			var style = "";

			Tab.clearGroup("topmenu");

			for(var n in data.menu) {
				var m = data.menu[n];

				var cm = "<div class='top topanim bcmenu' onmouseover='Menu.hoveringEvt(this);'>";
				var look = 0;

				if (m.look_at) look = m.look_at;
				if (m.look_at_y != null && m.look_at_y != undefined) look += "," + m.look_at_y;
				
				ms += 100;

//				cm += "<a href='#' class='topmenu' style='background-color:" + Menu.getMenuColor(m) + "' onclick='Menu.openUrl(\"" + m.pano_id + "\", false, \"" + look + "\");'>" +  Menu.renderMenuItem(m) + (m.childs ? " <span class='down'><i class='fa fa-caret-down' aria-hidden='true'></i></span>":"") + "</a>";
				// "<span class='accent' style='background-color:" + Menu.getMenuColor(m) + "'></span>"

				cc = Menu.getMenuColor(m);
				style = "";

				if (cc != "transparent") {
					style = "style='background-color:" + cc + "'";
				}
				var ltitle = Menu.removeHtml(Menu.renderMenuItem(m));
				if (m.pano_id.indexOf("link=") !== -1) ltitle = "Otwórz link \"" + Menu.removeHtml(Menu.renderMenuItem(m)) + "\" w nowej zakładce";
				cm += "<a href='#' title='" + ltitle + "' class='topmenu speaks' " + style + " data-speak='" + m.title + "' onclick='Menu.openUrlEvt(\"" + m.pano_id + "\", false, \"" + look + "\", event);'>" + Menu.renderMenuItem(m) + (m.childs ? " <span class='down'><i class='fa fa-caret-down' aria-hidden='true'></i></span>":"") + "</a>";

				cm += Menu.submenu(m.childs, cc, true);

				cm += "</div>";

				var cmnode = $(cm);

				hm.append(cmnode);

				m.node = cmnode;

				Tab.add("topmenu", {
					"focus": function(m) {
						//console.log("focus " + m.title);
						m.node.find(".topmenu").addClass("focused");
						m.node.find(".topmenu").focus();
						m.midx = -1;
						m.bc = [];
						m.items = m.node.children(".sub").children(".menuitem");

					},

					"blur": function(m) {
						//console.log("blur " + m.title);
						m.node.find(".topmenu").removeClass("focused");
						m.node.removeClass("opened");
						$("#menu_breadcrumbs").removeClass("fade");

						if (m.midx && m.midx > -1) {
							//var items = m.node.children(".sub").children(".menuitem");
							$(m.items.eq(m.midx)).removeClass("selected");
						}
						m.midx = -1;
					},

					"action": function(m, event) {
						if (m.midx == -1) {

							if (m.items.length > 0) {
								m.node.toggleClass("opened");
								$("#menu_breadcrumbs").toggleClass("fade");
							} else {
								//console.log(m.node);
								m.node.find("a").click();
							}
						} else {
							//var items = m.node.children(".sub").children(".menuitem");
							$(m.items.eq(m.midx)).click();
							m.node.removeClass("opened");
							$("#menu_breadcrumbs").removeClass("fade");
							event.preventDefault();
							event.stopPropagation();
						}
					},

					"keyboard": function(m, event) {
						/*
						try {
							var items = m.node.children(".sub").children(".menuitem");
						} catch (e) {

						}
						*/
						if (m.node.hasClass("opened")) {
							player.keys['ArrowLeft'] = 0;
							player.keys['ArrowRight'] = 0;
							player.keys['ArrowUp'] = 0;
							player.keys['ArrowDown'] = 0;

							if (event.key == "Escape") {
								m.node.toggleClass("opened");
								$("#menu_breadcrumbs").toggleClass("fade");

								event.preventDefault();
								event.stopPropagation();
							}
						}

						if (event.key == "ArrowLeft") {
							if (m.bc.length > 0) {
								if (m.midx > -1) $(m.items.eq(m.midx)).removeClass("selected focused");
								var pr = m.bc.pop();
								m.items = pr.items;
								m.midx = pr.midx;
								$(m.items.eq(m.midx)).addClass("selectedvfocused");
								$(m.items.eq(m.midx)).trigger("speaks");
							}
						}

						if (event.key == "ArrowRight") {
							var nitems = $(m.items.eq(m.midx)).children(".sub").children(".menuitem");
							if ($(nitems).length > 0) {
								m.bc.push({"midx" : m.midx, "items": m.items});
								m.items = nitems;
								m.midx = 0;
								$(m.items.eq(m.midx)).addClass("selected focused");
								$(m.items.eq(m.midx)).trigger("speaks");
							}
						}

						if (event.key == "ArrowDown") {
							if (m.midx >= $(m.items).length - 1) return;

							if (m.midx > -1) $(m.items.eq(m.midx)).removeClass("selected focused");
							m.midx ++;
							$(m.items.eq(m.midx)).addClass("selected focused");
							$(m.items.eq(m.midx)).trigger("speaks");
						};

						if (event.key == "ArrowUp" && m.midx > 0) {
							if (m.midx > -1) $(m.items.eq(m.midx)).removeClass("selected focused");
							m.midx --;
							if (m.midx > -1) $(m.items.eq(m.midx)).addClass("selected focused");							
							$(m.items.eq(m.midx)).trigger("speaks");
						}
					}
				}, m, 0);
			}

			hm.find(".sub").each(function(idx) {
				//console.log("found sub " + idx);
				var observer = new MutationObserver(function(mutations) {
				    for(var m in mutations) {
				    	$(mutations[m].target).find("img").each(function(idx) {
				    		$(this).on("load", function() {
				    			$(this).css("opacity", 1);
				    		});

				    		$(this).attr("src", $(this).data('src'));				    		
				    		
				    	});
				    }
				});

				var target = this;
				observer.observe(target, {
				    attributes: true
				});				
			});
			/*
			$("body").on("show", ".img", function() {
				console.log("show");
				var src = $(this).data('src');
				$(this).find("img").attr("src", src);
			});
			*/

			var cm = "";
			cm += "<div class='top right' style='pointer-events:none;z-index:2'>";
			//cm += "<a href='#' onclick='Help.open();' class='expandable topicon righticon speaks' data-speakgroup='TIPS' data-speak='PLAYER.HELP_BUTTON'><i class='fa fa-question' aria-hidden='true'></i><span class='tip'>Pomoc</span></a>";
			cm += "<div onclick='#' aria-hidden='true' tabindex='0' class='popup topicon righticon speaks' data-speakgroup='TIPS' data-speak='PLAYER.HELP_BUTTON'><i class='fa fa-question' aria-hidden='true'></i>";
			cm += "<div class='submenu' style='padding: 0px;'>";
			cm += "<span onclick='Help.open();' class='speaks' style='padding: 10px;' data-speak=''>" + TPL.lng('menu.help', "Pomoc") + "</span>";
			cm += "<span onclick='Help.about();' class='speaks' style='padding: 10px;' data-speak='" + TPL.lng('menu.realization', "Realizacja") + "'>" + TPL.lng('menu.realization', "Realizacja") + "</span>";
			cm += "</div></div></div>";
			var cmn = $(cm);
			hm.append(cmn);
			
			//Menu.addTabToIcon(TPL.lng('menu.help', "Pomoc"), "", cmn);
			Menu.helpTab.params.node = cmn;
			Menu.helpTab.params.subnode = cmn;
			Menu.helpTab.params.title = TPL.lng('menu.help', "Pomoc"); 

			for(var i in Menu.icons) {
				hm.append(Menu.icons[i]);
			}

			cm = "";
			cm += "</div><div class='top right' style='pointer-events:none;'>";
			cm += "<a href='#' aria-hidden='true' onclick='Search.open();' id='tsrchbtn' class='topicon righticon speaks ttip' data-ttip='" + TPL.lng("tips.search", 'Szukaj') + "' data-speakgroup='TIPS' data-speak='PLAYER.SEARCH'><i class='fa fa-search' aria-hidden='true'></i></a>";
			cm += "</div><div class='top right' style='pointer-events:none;'>";
			cm += "<a href='#' aria-hidden='true' id='tmapbtn' class='topicon righticon speaks ttip' data-ttip='" + TPL.lng("tips.map", 'Mapa') + "' data-speakgroup='TIPS' data-speak='PLAYER.MAP'><i class='fa fa-globe-americas' aria-hidden='true'></i></a>";
			cm += "</div>";
			if (data.folder.languages.length > 1) {
				cm += "<div class='top right' style='pointer-events:none;'>";
				cm += "<div onclick='' id='langbtns' class='expandable topicon righticon speaks ttip' data-ttip='" + TPL.lng("tips.lang", 'Języki') + "' data-speakgroup='TIPS' data-speak='HTML5.tips.lang' tabindex='0'>";
				if (player.offline) {
					cm += "<img src='flags/hd/" + (player.lang.toLowerCase() != "" ? player.lang.toLowerCase() : "pl") + ".png' width='17' style='pointer-events:none;'>";
					for(var lang in data.folder.languages) {
						if (data.folder.languages[lang] != player.lang) cm += "<span onclick='LanguageMenu.go(\"" + lang + "\")'><img src='flags/hd/" + data.folder.languages[lang].toLowerCase() + ".png' width='17'></span>";
					}
				} else {
					cm += "<img src='/flags/hd/" + (player.lang.toLowerCase() != "" ? player.lang.toLowerCase() : "pl") + ".png' width='17' style='pointer-events:none;'>";
					for(var lang in data.folder.languages) {
						if (data.folder.languages[lang] != player.lang) cm += "<span onclick='LanguageMenu.go(\"" + lang + "\")' class='speaks' data-speakgroup='TIPS' data-speak='HTML5.langs." + data.folder.languages[lang] + "'><img src='/flags/hd/" + data.folder.languages[lang].toLowerCase() + ".png' width='17'></span>";
					}
				}
				cm += "</div>";
			}
			cm += "</div>";

			hm.append(cm);

			var cm = "<div class='top infobutton'><div class='rect'></div><div class='rect'></div><div class='rect'></div>";
			cm += "<a href='#' title='" + TPL.lng("tips.placeinfo", "Informacja o miejscu") + "' class='topicon infoicon speaks'aria-flowto='iwindow' style='" + cs + "' data-speak='PLAYER.HELP.4.TITLE' data-speakgroup='TIPS'><i class='fa fa-info' aria-hidden='true'></i></a>";
			cm += "</div>";

			var cmnode = $(cm);

			hm.append(cmnode);
			
			$(".infoicon").on("click", Menu.infowindow);


			Menu.addTabToIcon(TPL.lng("tips.search", 'Szukaj'), "", $($("#tsrchbtn").parent()));
			Menu.addTabToIcon(TPL.lng("tips.map", 'Mapa'), "", $($("#tmapbtn").parent()));

			if (data.folder.languages.length > 1) {
				Menu.addTabToIcon(TPL.lng("tips.lang", 'Języki'), "", $($("#langbtns").parent()), 0, "#langbtns", "span", undefined, $($("#langbtns").parent()));
			}

			var sheet = document.createElement('style');
			var hh = Math.round(15 + (data.folder.languages.length - 1) * 43) + "px !important";
			sheet.innerHTML = ".expandable:hover {height:" + hh + "} #langbtns.hovered {height:" + hh + "} .expanded {height: " + hh + "}";
			document.body.appendChild(sheet);

			setTimeout(function() {$("#langbtns").removeClass("expanded");}, 7000);

			//$("#tmapbtn").on(Events.pointer.down, function() {mapInfo.toggleMenuDesktop();});	
			$("#tmapbtn").on(Events.pointer.down, function() {mapInfo.clickToggleMiniMap();});	
			$("#tmapbtn").on("keydown", function(evt) { if (evt.key == "Enter") mapInfo.clickToggleMiniMap();});	

			hm.append("<div id='menu_breadcrumbs' aria-hidden='true'></div><div id='ttip-popup'></div>");

			Menu.firstLoad = false;

			setTimeout(function() {
				Menu.prepareBc(Menu.placedata);
			}, 2500);

			AppEvent.trigger(player, "MENU.REBUILD", true);

			$(".ttip").each(function(idx) {
				var s = $(this);

				s.on("mouseover", function() {
					var e = $(this);
					$("#ttip-popup").html(e.data('ttip'));
					var ax = e.offset().left + (e.outerWidth() * 0.5) - ($("#ttip-popup").outerWidth() * 0.5);
					$("#ttip-popup").css("left", ax);
					$("#ttip-popup").css("top", e.offset().top + e.outerHeight() + 5);
					$("#ttip-popup").show();
				});

				s.on("mouseout", function() {
					$("#ttip-popup").hide();
				});
			});
		}

		//if (data.place_type == 'panorama') $("#tmapbtn").hide(); else $("#tmapbtn").show();

		if ((data.properties.info_state == "full" || data.properties.info_state == "fullext") && $(window).width() > 400) {
			Menu.forcedInfo = player.ident;
			Menu.showinfowindow();
		}

		if (Menu.forcedInfo != player.ident && Menu.forcedInfo != "") {
			Menu.forcedInfo = "";
			Menu.hideinfowindow();
		}

		var j = player.current;
		//console.log("desc: " + j.description);
		//console.log("inds: " + j.indicators);

		if ((j.description != undefined && j.description != "") || (j.parentplace != undefined && j.parentplace.description != undefined && j.parentplace.description != "") || (j.indicators != undefined && j.indicators.length > 0)) {			
			$(".infoicon").css("display","block");
			$(".infoanim").css("display","block");
			$(".infoicon").css("visibility","visible");
			$("#menu_breadcrumbs").css("left",$($("#hmenu .bcmenu")[Menu.topMenuIndex]).position().left);

			Tab.add("info", {
				"focus": function(m) {
					//console.log("focus info");
					$(".infoicon").addClass("focused");
					$(".infoicon").focus();
				},

				"blur": function(m) {
					//console.log("blur info");
					$(".infoicon").removeClass("focused");
				}
			}, {});

		} else {
			//console.log("hide icon");
			$(".infoicon").css("display","block");
			$(".infoanim").css("display","block");
			$(".infoicon").css("visibility","hidden");
			$(".infoanim").css("visibility","hidden");
		}

		if (j.indicators.length > 0) {
			$(".indicators").show();
		} else {
			$(".indicators").hide();
		}
	},

	inMenu: function(childs) {
		for(var n in childs) {
			if (childs[n].pano_id == player.ident) {
				Menu.breadcrumbs.push({'title':childs[n].title, 'index':n});
				return 1;
			}

			if (childs[n].childs) {
				if (Menu.inMenu(childs[n].childs)) {
					Menu.breadcrumbs.push({'title':childs[n].title, 'index':n});
					return 1;
				}
			}
		}

		return 0;
	},

	openUrl: function(url, blank, dir) {
		if (url == "") return;

		if (Autoplay.isRunning) {
			Autoplay.stop();
		}

		$("#panels .sub").css("display", "none");

		if (Menu.currentMenu) {
			Menu.currentMenu.css("display", "none");
		}
		//setTimeout(function() { Menu.currentMenu.removeClass("subhide"); }, 40);		

		setTimeout(function() { 
			$("#panels .sub").css("display", "");
			Menu.currentMenu.css("left", "");
		}, 40);

		if (url.substr(0,5) == "quest") {
			QuestManager.load(dir);
			return;
		}

		if (url.substr(0,5) == "quiz") {
			Quiz.open(dir);
			return;
		}

		if (url.substr(0,6) == "folder") {
			Library.open(dir);
			return;
		}

		if (url.substr(0,5) == "link=") {
			url = "http://" + url.substr(5);
			blank = true;
		}

		if (url.substr(0,6) == "hlink=") {
			url = "https://" + url.substr(6);
			blank = true;
		}

		if (!blank) 
			player.go(url, dir);
		else {
			var win = window.open(url, '_blank');
			if (win == null || typeof(win)=='undefined') {
				if (confirm("Twoja przeglądarka blokuje otwieranie nowych okien. Czy chcesz otworzyć ten link w bieżącym oknie ?")) {
					document.location = url;
				}
			}
		}
	},

	openUrlEvt: function(url, blank, dir, e) {
		this.openUrl(url, blank, dir);
		e.preventDefault();
		e.stopPropagation();
		return false;
	},

	initIwindowTabs: function() {
		Tab.cancelStackAdd("iwindow", Menu.infowindow);
		Tab.clearGroup("iwindow");
		Tab.clearGroup("iwin.wcag");
		Tab.clearGroup("iwin.close");
		Menu.addBasicTab("iwindow", $("#iwindow #wcagicon"));
		Menu.addBasicTab("iwin.close", $("#iwindow .pdf"));
		Menu.addBasicTab("iwin.close", $("#iwindow .e"));
		Menu.addBasicTab("iwin.close", $("#iwindow .x"));
		Menu.addBasicTab("iwin.close", $("#iwindow .content"), $("#iwindow .content p"), function(m) {
			if (m.node.hasClass("focused")) {
				player.keys['ArrowLeft'] = 0;
				player.keys['ArrowRight'] = 0;
				player.keys['ArrowUp'] = 0;
				player.keys['ArrowDown'] = 0;

				if (event.key == "ArrowDown") {
					if (m.st == undefined) m.st = 0;
					m.st += 10;
					m.node.scrollTop(m.st);
					m.st = m.node.scrollTop();
				};

				if (event.key == "ArrowUp") {
					if (m.st == undefined) m.st = 0;
					m.st -= 10;
					m.node.scrollTop(m.st);
					m.st = m.node.scrollTop();
				}
			}
		});
	},

	infowindow_full: function() {
		$("#iwindow").toggleClass("wide");		
		$("#iwindow").css("max-width", '');
		$("#iwindow .content").css("max-height", '');

		var data = Menu.data;

		if (!$("#iwindow").hasClass("wide")) {
			if (data.properties.info_width != undefined && data.properties.info_width != null && data.properties.info_width != "0") {
				$("#iwindow").css("max-width", data.properties.info_width + "px");
			}
			if (data.properties.info_height != undefined && data.properties.info_height != null && data.properties.info_height != "0") {
				if (!Screen.mobile()) $("#iwindow .content").css("max-height", data.properties.info_height + "px");
			}
		}
	},

	infowindow: function() {
		$("#iwindow").css({"cssText": ""});
		
		$("#iwindow").toggleClass("iwindow_show");
		$(".infoanim").removeClass("infoanim");
		$(".infoicon").toggleClass("infoicon_down");

		if ($("#iwindow").hasClass("iwindow_show")) {
			Menu.initIwindowTabs();
			AppEvent.trigger(player, "MENU.INFOWINDOW.TOGGLE", true);
		} else {
			Tab.clearGroup("iwindow");
			Tab.clearGroup("iwin.wcag");
			Tab.clearGroup("iwin.close");
			Tab.cancelStackRemove("iwindow", Menu.infowindow);
			AppEvent.trigger(player, "MENU.INFOWINDOW.TOGGLE", false);
		}

		Menu.updateInfoText();
	},

	showinfowindow: function(d2) {
		var data = Menu.placedata;

		if (d2 != undefined) data = d2;

		if (data.properties.info_left != undefined && data.properties.info_top != undefined) {
			$("#iwindow").css({"cssText": "left: " + (data.properties.info_left + 15) + "px !important;\ntop: " + (data.properties.info_top + 15) + "px !important"});
		} else {
			$("#iwindow").css({"cssText": ""});
		}

		if (data.properties.info_width != undefined && data.properties.info_width != null && data.properties.info_width != "0") {
			$("#iwindow").css("max-width", data.properties.info_width + "px");
		}

		if (data.properties.info_height != undefined && data.properties.info_height != null && data.properties.info_height != "0") {
			if (!Screen.mobile()) $("#iwindow .content").css("max-height", data.properties.info_height + "px");
		}

		$("#iwindow").addClass("iwindow_show");
		$(".infoanim").removeClass("infoanim");
		$(".infoicon").addClass("infoicon_down");

		AppEvent.trigger(player, "MENU.INFOWINDOW.TOGGLE", true);

		Menu.initIwindowTabs();

		Menu.updateInfoText(undefined, d2);
	},

	updateInfoText: function(transit, data) {
		var j = Menu.data;
		if (j == undefined) j = player.current;
		var desc = "";
		
		if (data != undefined) j = data;

		var cdesc = j.description;
		if (cdesc == undefined || cdesc.trim() == "") {
			if (j.parentplace != undefined && j.parentplace.description != undefined && j.parentplace.description.trim() != "") {
				cdesc = j.parentplace.description;
			}
		}

		$("#iwindow .tabs").hide();

		if (cdesc != undefined && cdesc == "" && j.indicators.length == 0) {
			Menu.hideinfowindow();
		}

		if (cdesc != undefined) {
			desc = cdesc;
//			desc = cdesc.replace(/\n/g, '<br />');
//			desc = desc.replace(/\r/g, '') + "<br><br><br><br><br><br>&nbsp;";
			desc = desc.replace(/\r/g, '');
			
			if ($("#iwindow").hasClass("iwindow_show") && transit != undefined && Menu.lastDesc != desc && Menu.lastDesc != undefined) {
				$("#iwindow").attr("style", "opacity: 0 !important");
				setTimeout(function() {$("#iwindow .content").html(desc);
					$("#iwindow").attr("style", "transition: opacity 1s !important");}, 2000);

			} else {
				//setTimeout(function() {$("#iwindow .content").html(desc)}, 2000);
				$("#iwindow .content").html(desc);
			}

			Menu.lastDesc = desc;

		} else if (j.indicators.length == 0) {
			Menu.hideinfowindow();
		}

		if (j.indicators.length > 0) {
			$("#iwindow .indicators").html("");

			var recs = "<div class='indicators_info'>" + (j.indicators_info != null && j.indicators_info != undefined ? j.indicators_info.replace('\n', '<br>') : "") + "</div>";

			for(var n in j.indicators) {
				var ind = j.indicators[n];
				if (ind.hide == "1" || ind.hide == "2") continue;
				var loc = "";
				if (ind.title2 != undefined && ind.title2 != "") loc = ind.title2.replace(new RegExp('\n', 'g'), '<br>') + "<br><Br>";
				recs += "<div class='indicator' onclick='Menu.turnTo(" + ind.look_x + "," + (ind.look_y * -1) + ")'>";
				recs += "<span class='title'>" + ind.title + " " + ind.no + "</span>";
				recs += "<span class='info'>" + loc + ind.info.replace(new RegExp('\n', 'g'), '<br>') + "</span>";
				//recs += "<span class='info'>" + ind.info.replace('\n', '#') + "</span>";
				recs += "</div>";
			}

			//$("#iwindow .indicators").html(recs);
			if (j.indicators_tab == "1") {
				$("#iwindow .indicators").html(recs);
				$("#iwindow .indicators").hide();
				$("#iwindow .tabs").show();
				$("#iwindow .tabs .t2").html(j.indicators_tab_title);
			} else {
				$("#iwindow .tabs").hide();
				//setTimeout(function() {$("#iwindow .content").html(desc + recs)}, 2000);
				$("#iwindow .content").html(desc + recs);

			}
		}
	},

	turnTo: function(x,y) {
//		player.currentView.turnToAnd(x, y, {speed:100, rangeX:10, rangeY:20}, function() {});		
		player.currentView.turnTo(parseFloat(x) + 90 - 4, y);
	},

	tab: function(no) {
		if (no == 1) {
			$("#iwindow .wcag").show();
			$("#iwindow .content").show();
			$("#iwindow .indicators").hide();
			$("#iwindow .tabs .t1").addClass("selected");
			$("#iwindow .tabs .t2").removeClass("selected");
		} else if (no == 2) {
			$("#iwindow .wcag").hide();
			$("#iwindow .content").hide();
			$("#iwindow .indicators").show();
			$("#iwindow .tabs .t2").addClass("selected");
			$("#iwindow .tabs .t1").removeClass("selected");
		}
	},

	hideinfowindow: function() {
		$("#iwindow").removeClass("iwindow_show");
		//$(".infoanim").removeClass("infoanim");
		$(".infoicon").removeClass("infoicon_down");

		AppEvent.trigger(player, "MENU.INFOWINDOW.TOGGLE", false);
	},

	hideInfoIcon: function(st) {
		if (st) {
			$(".infoicon").css("display","none");
		} else {
			$(".infoicon").css("display","block");
		}
	}
}

PluginManager.add(Menu);